import { http, authHeader } from "@/http-commons";

class CashRegisterDataService {

    openCashRegister(cashRegister){
        return http.post(`api/v1/cashRegister/openCashRegister`, cashRegister, { headers: authHeader });
    }
    closeCashRegister(closedCashRegister){
        return http.post(`api/v1/cashRegister/closeCashRegister`, closedCashRegister, { headers: authHeader });
    }
    closeCashRegisterAdmin(cashRegisterId){
        return http.post(`api/v1/cashRegister/closeCashRegisterAdmin/${cashRegisterId}`, { headers: authHeader });
    }
    openCashRegisterClosed(cashRegisterId){
        return http.put(`api/v1/cashRegister/openCashRegisterClosed/${cashRegisterId}`, { headers: authHeader });
    }
    findCashRegisterOpenedByUser(userId){
        return http.get(`api/v1/cashRegister/findCashRegisterOpenedByUser/${userId}`, { headers: authHeader });
    }

    findCashRegisterOpenedByUserAndSucursal(userId, sucursalId){
        return http.get(`api/v1/cashRegister/findCashRegisterOpenedByUserAndSucursal/${userId}/${sucursalId}`, { headers: authHeader });
    }

    findCashRegisterBySucursal(){
        return http.get(`api/v1/cashRegister/findCashRegisterBySucursal`, { headers: authHeader()  });
    }

    findCashRegisterOpened(){
        return http.get(`api/v1/cashRegister/findCashRegisterOpened`, { headers: authHeader  });
    }
    
    table( params ){
        return http.get('api/v1/cashRegister/table', { params, headers : authHeader() });
    }
    printCashRegister(cashRegisterId, params){
        return http.get(`api/v1/cashRegister/printCashRegister/${cashRegisterId}`, { params,headers : authHeader(), responseType: 'blob' });
    }
}

export default new CashRegisterDataService();

